import { SITE } from "../lib/site";

/**
 * Logo component.
 *  - variant="light" (default): logo classique sur fond blanc.
 *  - variant="dark": logo entouré d'un petit cadre blanc pour rester lisible
 *    sur fond foncé (technique standard et fiable, équivalente à une version inversée).
 */
export const Logo = ({ variant = "light", className = "h-12", alt = "Eco-Gest Patrimoine" }) => {
  if (variant === "dark") {
    return (
      <div className="inline-block bg-white p-3">
        <img
          src={SITE.logo}
          alt={alt}
          className={`${className} w-auto object-contain`}
        />
      </div>
    );
  }
  return <img src={SITE.logo} alt={alt} className={`${className} w-auto object-contain`} />;
};

export default Logo;
